module.exports = __webpack_public_path__ + "static/media/main-logos.91abca59.svg";